import WithRoutePermission from "shared/components/HOC/WithRoutePermission";
import { MODULES, SCREENS, SUBMODULES } from "utils/constants";
import Create from "./Create";
import Delete from "./Delete";
import Detail from "./Detail";
import List from "./List";

const routes = [
  {
    path: SCREENS.PRIVATE.ADMIN.BRANDS.LIST.path,
    exact: true,
    element: (
      <WithRoutePermission
        submodules={{
          [MODULES.MODEL]: SUBMODULES.ADMIN_LIST,
          [MODULES.BRAND]: SUBMODULES.ADMIN_LIST,
        }}
        WrappedComponent={List}
      />
    ),
  },
  {
    path: SCREENS.PRIVATE.ADMIN.BRANDS.CREATE.path,
    exact: true,
    element: (
      <WithRoutePermission
        submodules={{
          [MODULES.BRAND]: SUBMODULES.ADMIN_CREATE,
          [MODULES.MODEL]: SUBMODULES.ADMIN_CREATE,
        }}
        WrappedComponent={Create}
      />
    ),
  },
  {
    path: `${SCREENS.PRIVATE.ADMIN.BRANDS.DETAIL.path}/:id`,
    exact: true,
    element: (
      <WithRoutePermission
        submodules={{
          [MODULES.MODEL]: SUBMODULES.ADMIN_DETAIL,
          [MODULES.BRAND]: SUBMODULES.ADMIN_DETAIL,
        }}
        WrappedComponent={Detail}
      />
    ),
  },
  {
    path: `${SCREENS.PRIVATE.ADMIN.BRANDS.DELETE.path}/:id`,
    exact: true,
    element: (
      <WithRoutePermission
        submodules={{
          [MODULES.MODEL]: SUBMODULES.ADMIN_DELETE,
          [MODULES.BRAND]: SUBMODULES.ADMIN_DELETE,
        }}
        WrappedComponent={Delete}
      />
    ),
  },
];

export default routes;
